var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon17(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.25 0H4.75C3.233 0 2 1.233 2 2.75V21.25C2 22.767 3.233 24 4.75 24H19.25C20.767 24 22 22.767 22 21.25V2.75C22 1.233 20.767 0 19.25 0ZM10.75 13V8.076C13.15 8.441 15 10.5 15 13C15 15.757 12.757 18 10 18C8.892 18 7.877 17.626 7.047 17.013L10.53 13.53C10.671 13.39 10.75 13.199 10.75 13ZM9.25 8.076V12.69L5.987 15.953C5.374 15.123 5 14.108 5 13C5 10.5 6.85 8.441 9.25 8.076ZM18.25 21.25H5.75C5.336 21.25 5 20.914 5 20.5C5 20.086 5.336 19.75 5.75 19.75H18.25C18.664 19.75 19 20.086 19 20.5C19 20.914 18.664 21.25 18.25 21.25ZM18.25 18H16.75C16.336 18 16 17.664 16 17.25C16 16.836 16.336 16.5 16.75 16.5H18.25C18.664 16.5 19 16.836 19 17.25C19 17.664 18.664 18 18.25 18ZM18.25 15.25H16.75C16.336 15.25 16 14.914 16 14.5C16 14.086 16.336 13.75 16.75 13.75H18.25C18.664 13.75 19 14.086 19 14.5C19 14.914 18.664 15.25 18.25 15.25ZM18.25 12.25H16.75C16.336 12.25 16 11.914 16 11.5C16 11.086 16.336 10.75 16.75 10.75H18.25C18.664 10.75 19 11.086 19 11.5C19 11.914 18.664 12.25 18.25 12.25ZM18.25 9.5H16.75C16.336 9.5 16 9.164 16 8.75C16 8.336 16.336 8 16.75 8H18.25C18.664 8 19 8.336 19 8.75C19 9.164 18.664 9.5 18.25 9.5Z",
    fill: "#C32A7C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon17);
export default __webpack_public_path__ + "static/media/icon17.9b5e81f58a1141cbe80d9c6c4c01d4b6.svg";
export { ForwardRef as ReactComponent };